export const documentTemplateSliceName = "documentTemplates"
